import { Column } from '@acceso/design-system';

import { RenderActionButtons } from '@/components/RenderActionButtons';
import { TableRow } from '@/components/TableRow';
import { useBroadcastScheduleProgram } from '@/features/broadcast-schedule-program/context/BroadcastScheduleProgramContext';
import { TSegmentMention } from '@/features/segments/types';
import { getOffsetHHMMSS } from '@/utils/hh-mm-ss-into-number';

import { TGroupedMention } from './BroadcastScheduleProgramBodySegmentToolkitMentionTable';

type TBroadcastScheduleProgramBodySegmentToolkitSubTableProps = {
  item: TGroupedMention;
  columns: Column<TGroupedMention>[];
  onPreview?: (item: TSegmentMention) => void;
};

export function BroadcastScheduleProgramBodySegmentToolkitMentionSubTable({
  item,
  columns,
  onPreview,
}: TBroadcastScheduleProgramBodySegmentToolkitSubTableProps) {
  const { activeSegment } = useBroadcastScheduleProgram();

  if (!activeSegment) {
    return null;
  }

  return (
    <td colSpan={columns.length} className="max-h-10 p-0">
      <table className="w-full border-separate border-spacing-0">
        <colgroup>
          {columns.map((column, index) => (
            <col
              key={index}
              style={{
                width: column.width || `${100 / columns.length}%`,
                maxWidth: column.width || `${100 / columns.length}%`,
                minWidth: column.minWidth || 'auto',
              }}
            />
          ))}
        </colgroup>
        <tbody className="table-row-group">
          {item.children &&
            item.children.length > 0 &&
            item.children.map(child => {
              const seconds = getOffsetHHMMSS(child.start_datetime, activeSegment?.start_datetime);
              return (
                <tr
                  key={child.segment_id}
                  className="group mb-size-12 table-row border-b border-neutral-30 transition first:mt-size-12 last:mb-0 hover:bg-neutral-10"
                >
                  <td className="table-cell gap-size-12 p-size-8 pr-size-20"></td>
                  <td className="table-cell gap-size-12 p-size-8 pr-size-20"></td>
                  <td className="table-cell gap-size-12 p-size-8 pr-size-20">
                    <TableRow content={seconds} />
                  </td>
                  <td className="table-cell gap-size-12 p-size-8 pr-size-20">
                    <RenderActionButtons item={child} onPreview={() => onPreview?.(child)} />
                  </td>
                </tr>
              );
            })}
        </tbody>
      </table>
    </td>
  );
}
